import { render, staticRenderFns } from "./SGDbOpsSummary.vue?vue&type=template&id=dd017794"
import script from "./SGDbOpsSummary.vue?vue&type=script&lang=js"
export * from "./SGDbOpsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports